import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ManageCampaignService {

  constructor(private http: CustomHttpService) { }

  getAllManangeCampaign(data: any): Observable<any> {
    return this.http.post(environment.getAllManangeCampaign, data);
  }

  getAllWhatsappTemplatesGupshup(data: any): Observable<any> {
    return this.http.post(environment.getAllWhatsappTemplatesGupshup, data);
  }

  getAllEmailTemplates(data: any): Observable<any> {
    return this.http.post(environment.getAllEmailTemplates, data);
  }

  getAllContactGroups(data: any): Observable<any> {
    return this.http.post(environment.getAllContactGroups, data);
  }

  createCampaign(data: any): Observable<any> {
    return this.http.post(environment.createCampaign, data);
  }

  updateCampaign(data: any): Observable<any> {
    return this.http.post(environment.updateCampaign, data);
  }

  getTemplateById(data: any): Observable<any> {
    return this.http.post(environment.getGupshuTemplateById, data);
  }

  getEmailTemplateById(data: any): Observable<any> {
    return this.http.post(environment.getEmailTemplateById, data);
  }

  runCampaign(data: any): Observable<any> {
    return this.http.post(environment.runCampaign, data);
  }


  deleteCampaign(data: any): Observable<any> {
    return this.http.post(environment.deleteCampaign, data);
  }

  runCallCampaign(data : any): Observable<any> {
     return this.http.post(environment.runTelephonyCampaign, data);
  }

  testDialCustomer(data : any): Observable<any> {
    return this.http.post(environment.testDialCustomer, data);
  }


  getCountOfContactsInGroup(data: any): Observable<any> {
    return this.http.post(environment.getCountOfContactsInGroup, data);
  }


  getEmailCampaignReport(data: any): Observable<any> {
    return this.http.post(environment.getEmailCampaignReport, data);
  }

  getWhatsappCampaignReport(data: any): Observable<any> {
    return this.http.post(environment.getWhatsappCampaignReport, data);
  }

  testWhatsappCampaign(data: any): Observable<any> {
    return this.http.post(environment.testWhatsappCampaign, data);
  }

  testEmailCampaign(data: any): Observable<any> {
    return this.http.post(environment.testEmailCampaign, data);
  }

}